import request from "../utils/request";
export function sendForm(data) {
  return request({
    url: "/business/coop/add",
    method: "post",
    params: data,
  });
}
